export const TYPES = {
    FLOAT: 'Float',
    INTEGER: 'Integer',
    BOOLEAN: 'Boolean',
    STRING: 'String'
}

/**
 * Converts given value to a specific type.
 * @param {string} value - The value to convert.
 * @param {string} type - The type to convert to.
 * @returns {number|string|boolean} - The converted value.
 */
export function convertType(value, type) {
    switch (type) {
    case TYPES.FLOAT:
        return parseFloat(value)
    case TYPES.INTEGER:
        return parseInt(value, 10)
    case TYPES.BOOLEAN:
        return Boolean(value)
    case TYPES.STRING:
        return value.toString()
    default:
        return value
    }
}
